import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvAgriNewsStore = new MMKV({
    id: MMKVStoreKeyMap.agriNewsStore,
});

export const zustandAgriNewsStore: StateStorage = {
  setItem(name: string, value: string) {
        return mmkvAgriNewsStore.set(name, value);
  },
  getItem(name: string) {
      const value = mmkvAgriNewsStore.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
      return mmkvAgriNewsStore.delete(name);
  },
};